import type { RankOption } from "gsintegrations";
import { axiosClient } from "../api/axiosClient";

export const rankRepository = {
  async getRanks(): Promise<RankOption[]> {
    try {
      const { data } = await axiosClient.get<RankOption[]>("/rank", {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      console.error("Error fetching roles:", error);
      throw error;
    }
  },
};
